module.exports = __webpack_public_path__ + "img/inst-modal-3.d0b957f5.png";